import { Component, Element, Prop, getAssetPath, h } from '@stencil/core';
import state from '../../store';
import { scrollToTop } from '../../utils/scroll';

@Component({
  tag: 'hemfixarna-breadcrumbs',
  shadow: false,
})
export class HemfixarnaBreadcrumbs {
  @Prop() closeModal: () => void;
  @Element() private el: HTMLElement;

  getCartLength() {
    return state.cart.reduce((acc, curr) => acc + curr.amount, 0);
  }

  triggerScrollTotop = () => {
    const el = this.el.nextSibling as HTMLElement;
    scrollToTop(el);
  };

  handleCartClick() {
    if (state.cart?.length) {
      state.step = 5;
      this.triggerScrollTotop();
    }
  }

  handleHomePageClick() {
    state.step = 1;
    state.parentCategory = null;
    state.selectedCustomerCategory = null;
    this.triggerScrollTotop();
    setTimeout(() => {
      state.selectedCategory = null;
      state.selectedProduct = null;
      state.maleri = null;
      state.selectedService = null;
    }, 200);
  }

  render() {
    const logo = getAssetPath(`./assets/hemfixarna.svg`);
    const close = getAssetPath(`./assets/close.svg`);
    const cart = getAssetPath(`./assets/cart.svg`);
    const back = getAssetPath(`./assets/back.svg`);

    return (
      <div>
        <div class="hemfixarna_crumbs">
          <div class="hemfixarna_crumbs--links">
            <img onClick={() => this.handleHomePageClick()} src={logo} width={110} />
            <img onClick={() => this.closeModal()} class="close" src={close} width={32} />
            <div>
              <button onClick={() => this.handleHomePageClick()}>Alla tjänster</button>
            </div>
          </div>
          <div class="hemfixarna_crumbs--right">
            <hemfixarna-contact></hemfixarna-contact>
            <div onClick={() => this.handleCartClick()} class={`cart ${this.getCartLength() > 0 ? 'cart_active' : ''}`}>
              <img src={cart} width={24} />
              <span>{this.getCartLength()}</span>
            </div>
          </div>
        </div>
        {[3, 4].includes(state.step) && !state.customer && (
          <button
            class="hemfixarna_crumbs--back"
            onClick={() => {
              state.step = state.step === 4 ? 3 : 2;
            }}
          >
            <img width={24} src={back} alt="back arrow" />
            <span>Se allt {state.step === 4 ? state.selectedService.post_title : state.selectedCategory.name}</span>
          </button>
        )}
        {!state.parentCategory && state.step && state.selectedCustomerCategory && (
          <button
            class="hemfixarna_crumbs--back"
            onClick={() => {
              state.step = 1;
              state.selectedCustomerCategory = null;
              state.selectedProduct = null;
              state.maleri = null;
            }}
          >
            <img width={24} src={back} alt="back arrow" />
            <span>Se alla tjänster</span>
          </button>
        )}
        {state.parentCategory && state.step < 5 && (
          <button
            class="hemfixarna_crumbs--back"
            onClick={() => {
              state.step = 1;
              state.selectedCustomerCategory = state.parentCategory;
              state.selectedProduct = null;
              state.maleri = null;
            }}
          >
            <img width={24} src={back} alt="back arrow" />
            <span>Se allt {state.parentCategory.name}</span>
          </button>
        )}
      </div>
    );
  }
}
